import Vue from 'vue'
import { mapState, mapActions } from 'vuex'
import { formatPrice } from 'utils/general'
import debounce from 'lodash/debounce'
import { i18n } from 'lib/i18n.js'

Vue.component('header-cart-item', resolve => {
  Promise.all([
    enqueueModule('quantity-selector.vue'),
    enqueueModule('vue-image.vue')
  ]).then(() => {
    resolve({
      i18n,
      name: 'header-cart-item',
      props: ['single', 'cartPage', 'maxQty'],
      data () {
        return {
          model: false,
          showQTY: true,
          engravingItem: {},
          engravingText: false
        }
      },
      watch: {
        single (_new, _old) {
          if (_old.quantity !== _new.quantity) {
            this.showQTY = false
            setTimeout(() => { this.showQTY = true }, 100)
          }
        },
        'cart.items': {
          deep: true,
          handler () {
            this.engravingItem = this.cart.items.find(e => e.properties && e.properties._key === this.single.properties._key && __GLOBAL__.engravingItem.id === e.id)
          }
        }
      },
      computed: {
        ...mapState('global', [
          'cart',
          'isMobile'
        ]),
        ...mapState('cart', [
          'cart_insoles',
          'loading'
        ]),
        maximumText () {
          return this.$t('cart.label.maximum')
        },
        discountedPrice () {
          return formatPrice(this.hasDiscount)
        },
        options () {
          return this.single.options_with_values
        },
        isEngravingItem () {
          return __GLOBAL__.engravingItem.id === this.single.variant_id
        },
        engravingItemQty () {
          const engravingItem = this.cart.items.find(item => item.variant_id === __GLOBAL__.engravingItem.id)
          if (engravingItem) {
            return engravingItem.quantity
          } else {
            return 0
          }
        }
      },
      methods: {
        ...mapActions('cart', [
          'updateItemQuantity',
          'addToCart'
        ]),
        updateQuantity: debounce(function (quantity) {
          this.updateItemQuantity({
            quantity,
            id: this.single.id
          })
        }, 450),
        async remove () {
          await this.updateItemQuantity({
            quantity: 0,
            id: this.single.id
          })

          if (this.engravingText && this.engravingItem.id) {
            await this.updateItemQuantity({
              quantity: 0,
              id: this.engravingItem.key
            })
          }
        },
        priceFormat (price) {
          return formatPrice(price)
        },
        option (optionItem) {
          return `${optionItem.name}: ${optionItem.value}`
        }
      },
      mounted () {
        if (this.single.properties) {
          if (this.single.properties.Text) {
            this.showQTY = false
            this.engravingItem = this.cart.items.find(e => e.properties && e.properties._key === this.single.properties._key && __GLOBAL__.engravingItem.id === e.id)
            this.engravingText = this.single.properties.Text
          }
        }
      },
      template: `
      <div class="w1 relative f jcb">
        <a :href="single.url" class="header-cart__element__image relative">
          <div
            is="vue-image"
            :src="single.featured_image.url"
            :size="190"
            :alt="single.product_title"
            spinner-size="sm"
            :transparent="true"
            css="fit-contain"
          ></div>
        </a>

        <div class="header-cart__element__data">
          <div class="header-cart__element__top">
            <a :href="single.url"
              class="header-cart__element__title"
              v-text="single.product_title"
            ></a>

            <div class="header-cart__element__options" v-if="single.options_with_values[0].value !== 'Default Title'">
              <p v-for="(optionItem, index) in options" v-text="option(optionItem)"></p>
            </div>

            <div class="header-cart__element__options" v-if="engravingText">
              <p>Text: <span v-text="engravingText"></span></p>
            </div>

            <div class="header-cart__element__prices">
              <div
                class="header-cart__element__price"
                v-text="priceFormat(single.price)"
              ></div>
              <div
                class="header-cart__element__price italic"
                v-if="engravingItem && engravingItem.id"
              >+{{priceFormat(engravingItem.price)}}</div>
            </div>
          </div>

          <div class="header-cart__element__bottom">
            <div class="relative header-cart__element__quantity" :class="{'header-cart__element__quantity--loading': (loading === single.id)}">
              <div v-if="showQTY" class="header-cart__element__quantity__input hide">
                <div
                  is="quantity-selector"
                  @change="updateQuantity"
                  :value="single.quantity"
                ></div>
              </div>
              <div v-else class="quantity-selector--loading"></div>

              <div class="header-cart__element__quantity__input">Quantity: <span>{{single.quantity}}</span></div>

              <div class="header-cart__element__remove" v-if="!isEngravingItem">
                <button class="grey-5 header-cart__element__remove__btn" @click="remove">Remove</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      `
    })
  })
})
